import * as React from 'react';
import {withStore} from "../hocs";
import {observer} from "mobx-react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


// @ts-ignore
@withStore
@observer
export default class QuizReport extends React.Component {
    componentDidMount() {
        // @ts-ignore
        const {store} = this.props;
        store?.pageQuizStore.init();

    }

    render() {
        // @ts-ignore
        const {store} = this.props;
        const {
            openDopInfo,
            handleOpenDopInfo,
            arrayAnswersFromDB,
            selectedIndex,
            showDopInfo
        } = store?.pageQuizStore


        let arrViewing = ["Более 1 раза в неделю", 0,
            "Более 2 раз в неделю", 0,
            "1 раз в две недели", 0,
            "1 раз в месяц", 0,
            "Реже", 0]
        let arrDevice = ["ПК (персональный компьютер)", 0,
            "Laptop (ноутбук)", 0,
            "Планшет", 0,
            "Телефон", 0]
        let arrOS = ["iPhone (ios)", 0,
            "Android", 0
        ]
        let arrNoAnswer = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        let arrYesAnswer = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]


        if (arrayAnswersFromDB) {
            arrayAnswersFromDB.forEach((element: any) => element.data.forEach((elem: any, index: number) => elem.indexValueSelected === "Нет" ? arrNoAnswer[index] += 1 : arrNoAnswer[index] += 0))
            arrayAnswersFromDB.forEach((element: any) => element.data.forEach((elem: any, index: number) => elem.indexValueSelected === "Да" ? arrYesAnswer[index] += 1 : arrYesAnswer[index] += 0))
            // @ts-ignore
            arrayAnswersFromDB.forEach((element: any) => element.data.forEach((elem: any,) => elem.indexValueSelected === "Более 1 раза в неделю" ? arrViewing[1] += 1 :
                // @ts-ignore
                elem.indexValueSelected === "Более 2 раз в неделю" ? arrViewing[3] += 1 :
                    // @ts-ignore
                    elem.indexValueSelected === "1 раз в две недели" ? arrViewing[5] += 1 :
                        // @ts-ignore
                        elem.indexValueSelected === "1 раз в месяц" ? arrViewing[7] += 1 :
                            // @ts-ignore
                            elem.indexValueSelected === "Реже" ? arrViewing[9] += 1 : null))
            // @ts-ignore
            arrayAnswersFromDB.forEach((element: any) => element.data.forEach((elem: any,) => elem.indexValueSelectedCheckBox && elem.indexValueSelectedCheckBox.includes("ПК (персональный компьютер)") ? arrDevice[1] += 1 :
                // @ts-ignore
                elem.indexValueSelectedCheckBox && elem.indexValueSelectedCheckBox.includes("Laptop (ноутбук)") ? arrDevice[3] += 1 :
                    // @ts-ignore
                    elem.indexValueSelectedCheckBox && elem.indexValueSelectedCheckBox.includes("Планшет") ? arrDevice[5] += 1 :
                        // @ts-ignore
                        elem.indexValueSelectedCheckBox && elem.indexValueSelected === "Телефон" ? arrDevice[7] += 1 : null))
            // @ts-ignore
            arrayAnswersFromDB.forEach((element: any) => element.data.forEach((elem: any,) => elem.indexValueSelectedCheckBox && elem.indexValueSelectedCheckBox.includes("iPhone (ios)") ? arrOS[1] += 1 :
                // @ts-ignore
                elem.indexValueSelectedCheckBox && elem.indexValueSelectedCheckBox.includes("Android") ? arrOS[3] += 1 : null))
        }


        // @ts-ignore
        return (
            <div>
                <h3 style={{textAlign: "center", padding: 10}}>Результат опроса пользователей на портале B2B</h3>
                <TableContainer component={Paper} style={{width: "75%", margin: "auto"}}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Вопрос</TableCell>
                                <TableCell align="left">Да</TableCell>
                                <TableCell align="left">Нет</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {arrayAnswersFromDB.length ? arrayAnswersFromDB[0].data.map((row: any, index: number) => (
                                <TableRow
                                    key={index}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell component="th" scope="row">
                                        <button onClick={() => handleOpenDopInfo(openDopInfo, index)}>
                                            {openDopInfo ? <div>&#9650;</div> : <div>&#9660;</div>}
                                        </button>
                                        <span onClick={() => handleOpenDopInfo(openDopInfo, index)} style={{cursor: "pointer"}}>{index + 1}. {row.subTitle}</span>

                                        {/* Отображение ответов на первый вопрос */}
                                        {index === 0 ? <>{arrViewing.map((item, ind) => (
                                            <>{ind === 1 || ind === 3 || ind === 5 || ind === 7 || ind === 9 ?
                                                <TableRow><h3 style={{
                                                    backgroundColor: "yellow",
                                                    textAlign: "center"
                                                }}> {item}</h3></TableRow> : <TableRow>{ind + 1}) {item}</TableRow>}</>
                                        ))}</> : null}
                                        {/*Отображение ответов на третий вопрос*/}
                                        {index === 2 ? <>{arrDevice.map((item, ind) => (
                                            <>{ind === 1 || ind === 3 || ind === 5 || ind === 7 ? <TableRow><h3
                                                style={{backgroundColor: "yellow", textAlign: "center"}}> {item}</h3>
                                            </TableRow> : <TableRow>{ind + 1}) {item}</TableRow>}</>
                                        ))}</> : null}
                                        {/*Отображение ответов на девятый вопрос*/}
                                        {index === 8 ? <>{arrOS.map((item, ind) => (
                                            <>{ind === 1 || ind === 3 ? <TableRow><h3
                                                style={{backgroundColor: "yellow", textAlign: "center"}}> {item}</h3>
                                            </TableRow> : <TableRow>{ind + 1}) {item}</TableRow>}</>
                                        ))}</> : null}
                                        {index === selectedIndex ? <TableRow>
                                            <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                                                <Collapse in={openDopInfo} timeout="auto" unmountOnExit>
                                                    <Box sx={{margin: 1}}>
                                                        <Typography variant="h6" gutterBottom component="div">
                                                            История ответов
                                                        </Typography>
                                                        <Table size="small" aria-label="purchases">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>user Email</TableCell>
                                                                    <TableCell>Дата</TableCell>
                                                                    <TableCell align="right">Текст ответа</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {showDopInfo.map((item: any) => (
                                                                    <TableRow>
                                                                        <TableCell component="th" scope="row">
                                                                            {item.userId}
                                                                        </TableCell>
                                                                        <TableCell>{item.createAt}</TableCell>
                                                                        <TableCell
                                                                            align="right">{item.inputValue}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </Collapse>
                                            </TableCell>
                                        </TableRow> : null}
                                    </TableCell>
                                    <TableCell>{arrYesAnswer[index] !== 0 ? arrYesAnswer[index] : null}</TableCell>
                                    <TableCell>{arrNoAnswer[index] !== 0 ? arrNoAnswer[index] : null}</TableCell>
                                </TableRow>
                            )) : null}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }
}